import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

// Servicio para el módulo de facturación masiva CFDI. 23/07/2026
@Injectable()
export class FacturacionMasivaService {

  constructor(private http: HttpClient) {}

  // Sube archivo Excel (.xlsx) para procesamiento masivo de CFDIs. 23/07/2026
  uploadLayout(file: File) {
    const url = `${environment.URL_SERVICIOS}/bulk_cfdis/upload`;
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post(url, formData, { observe: 'response' }).pipe(
      map((resp: any) => resp.body)
    );
  }

  // Consulta el estatus y detalle de un lote específico. 23/07/2026
  getBatch(batchId: number) {
    const url = `${environment.URL_SERVICIOS}/bulk_cfdis/batches/${batchId}`;

    return this.http.get(url).pipe(
      map((resp: any) => resp)
    );
  }

  // Obtiene listado de lotes del usuario actual. 23/07/2026
  getBatches() {
    const url = `${environment.URL_SERVICIOS}/bulk_cfdis/batches`;

    return this.http.get(url).pipe(
      map((resp: any) => resp)
    );
  }

}
